/* eslint-disable camelcase */
import React, { Component } from 'react';
import { Form } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga';
import { withFormik } from 'formik';
import * as Yup from 'yup';
import imageModal from './assets/managed.svg';
import { Input as FormInput } from '../../Form';
import { Button } from '../../Button/index';
import './ContactOption.css';

class ContactOption extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async handleSubmit(event) {
    ReactGA.event({
      category: 'Onboarding',
      action: 'Submit',
    });

    const { handleAddContactInfo, handleNextStep, values } = this.props;
    await handleAddContactInfo({ ...values });
    handleNextStep(event);
  }

  render() {
    const {
      handleChange,
      values: { means_of_contact },
      isSubmitting,
      isValid,
    } = this.props;

    const disableSubmit = isSubmitting || !isValid;

    const isPhoneNumber = means_of_contact === 'phone_number';
    const isEmail = means_of_contact === 'email';

    return (
      <div className="a">
        <div className="row">
          <div className="col text-center mb-6">
            <div className="h5 t-30 t-md-34">
              Congrats! Your project is being reviewed.
            </div>
            <p>
              One of our account managers will contact you in the next 2 hours
              to complete the process.
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-lg text-center">
            <img src={imageModal} className="mb-5" alt="" />
          </div>
          <div className="col-12 col-lg">
            <div className="row">
              <div className="col">
                <p className="t-19 font-weight-bold mb-3">
                  What is the best way to contact you?
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <Form>
                  <div className="form-row">
                    <div className="col mb-3">
                      <div className="custom-control custom-control-rd custom-radio">
                        <input
                          type="radio"
                          name="means_of_contact"
                          value="phone_number"
                          id="phone-radio"
                          className="custom-control-input"
                          onChange={handleChange}
                          defaultChecked={isPhoneNumber}
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="phone-radio"
                        >
                          Call Me
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="form-row">
                    {isPhoneNumber && (
                      <FormInput
                        type="phoneNumber"
                        name="phone_number"
                        className="phone_number-input my-3"
                        placeholder="555-555-5555"
                      />
                    )}
                  </div>
                  <div className="form-row">
                    <div className="col mb-3">
                      <div className="custom-control custom-control-rd custom-radio">
                        <input
                          type="radio"
                          name="means_of_contact"
                          value="email"
                          id="email-radio"
                          className="custom-control-input"
                          onChange={handleChange}
                          defaultChecked={isEmail}
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="email-radio"
                        >
                          Email Me
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="form-row">
                    {isEmail && (
                      <FormInput
                        type="text"
                        name="email"
                        className="email-input  my-3"
                      />
                    )}
                  </div>
                  <div className="form-row">
                    <div className="col mt-3">
                      <Button
                        className="btn-primary px-5"
                        rounded
                        title="Submit"
                        onClick={event => this.handleSubmit(event)}
                        disabled={disableSubmit}
                      />
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ContactOption.propTypes = {
  handleAddContactInfo: PropTypes.func,
  handleNextStep: PropTypes.func,
  handleChange: PropTypes.func,
  isSubmitting: PropTypes.bool,
  isValid: PropTypes.bool,
  values: PropTypes.object,
};

export default withFormik({
  mapPropsToValues: ({
    means_of_contact,
    phone_number,
    email,
    phone_number_ddi,
    user,
  }) => ({
    means_of_contact,
    phone_number: phone_number || user.phone_number,
    email: email || user.email,
    phone_number_ddi: user.phone_number_ddi || phone_number_ddi,
  }),
  validateOnBlur: false,
  validateOnChange: true,
  isInitialValid: false,
  validationSchema: Yup.object().shape({
    means_of_contact: Yup.string(),
    email: Yup.string().when('means_of_contact', {
      is: 'email',
      then: Yup.string()
        .email('Email is invalid')
        .required('Email is required')
        .nullable(),
      otherwise: Yup.string().nullable(),
    }),
    phone_number: Yup.string().when('means_of_contact', {
      is: 'phone_number',
      then: Yup.string()
        .required('Phone Number is required')
        .nullable(),
      otherwise: Yup.string().nullable(),
    }),
    phone_number_ddi: Yup.string().when('means_of_contact', {
      is: 'phone_number',
      then: Yup.string()
        .required('DDI is required')
        .nullable(),
      otherwise: Yup.string().nullable(),
    }),
  }),
  displayName: 'ContactOptionForm',
})(ContactOption);



// WEBPACK FOOTER //
// ./src/components/ProjectManagement/ContactOption/ContactOption.js